import React from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import logos from "../../../assets/images/logo_padrao_alinhado.png";

const ExcelDmae = ({ data = [], name = 'Download', columns = {}, buttonName = 'Download', allColumns = true }) => {
    const gerarExcel = async () => {
        if (data.length > 0) {

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Dados");
            const response = await fetch(logos);
            const imageBuffer = await response.arrayBuffer();
            let showcolumns = [];
            let apresentColumns = [];
            let letra = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
            if(allColumns){
                Object.keys(columns).forEach(chave => {
                    showcolumns.push(chave);
                    apresentColumns.push(columns[chave]);
                });
            }else{
                Object.keys(columns).forEach(chave => {
                    if (data[0][chave]) {
                        showcolumns.push(chave);
                        apresentColumns.push(columns[chave]);
                    }
                });
            }


            const numCol = apresentColumns.length > 6 ? (apresentColumns.length - 1) : 6;

            const imageId = workbook.addImage({
                buffer: imageBuffer,
                extension: "png",
            });

            worksheet.mergeCells("A1:" + letra[numCol] + "5");

            worksheet.addImage(imageId, {
                tl: { col: 0, row: 0 },
                br: { col: numCol, row: 5 }, //
                editAs: "oneCell",
            });
            worksheet.getCell("A1").alignment = { vertical: 'middle', horizontal: 'center' };

            worksheet.getRow(7).values = apresentColumns;

            const dadosParaInserir = data;
            dadosParaInserir.forEach((item, idx) => {
                worksheet.getRow(8 + idx).values = showcolumns.map(coluna => item[coluna]);
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            saveAs(blob, name + ".xlsx");
        }
    };

    return (
        <div style={{display: data.length >0 ? "block":"none"}}>
            <button className="btn btn-info" onClick={gerarExcel}>{buttonName}</button>
        </div>
    );
};

export default ExcelDmae; 